var _path, _path2, _path3, _path4, _path5, _path6, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutPot1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 152,
    viewBox: "0 0 342 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.346 111.64H140.27L135.832 53.7461H205.783L201.346 111.64Z",
    fill: "#FF9A7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M201.346 111.64H140.27L135.832 53.7461H205.783L201.346 111.64Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.653 64.4306H204.963L205.783 53.7461H135.832L136.653 64.4306Z",
    fill: "#FF9A7E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.653 64.4306H204.963L205.783 53.7461H135.832L136.653 64.4306Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M213.001 40.3652H128.999V54.4325H213.001V40.3652Z",
    fill: "#FF9A7E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M213.001 40.3652H128.999V54.4325H213.001V40.3652Z",
    fill: "white",
    fillOpacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 40,
    transform: "translate(0 111.641)",
    fill: "#9DC5C3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutPot1);
export default __webpack_public_path__ + "static/media/about_pot_1.b605794296ba337d149a15d7bb93c6ec.svg";
export { ForwardRef as ReactComponent };